import React from "react";
import { HeaderAction, HeaderState, SidebarTab, StyleTab } from "../../types";

interface SidebarProps {
    sidebarOpen: boolean;
    setSidebarOpen: (open: boolean) => void;
    activeSidebarTab: SidebarTab;
    setActiveSidebarTab: (tab: SidebarTab) => void;
    activeStyleTab: StyleTab;
    setActiveStyleTab: (tab: StyleTab) => void;
    selectedComponentId: string | null;
    state: HeaderState;
    dispatch: React.Dispatch<HeaderAction>;
    setSelectedComponentId: (id: string | null) => void;
    children?: React.ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({
    sidebarOpen,
    setSidebarOpen,
    activeSidebarTab,
    setActiveSidebarTab,
    children,
}) => {
    return (
        <div
            className={`mt-14 relative bg-white shadow-lg transition-all duration-300 z-20 ${sidebarOpen ? "w-80" : "w-10"
                }`}>
            {sidebarOpen ? (
                <>
                    <div className="p-0">
                        <div className="flex border-b pr-4">
                            <button
                                className={`py-3 px-4 flex-1 ${activeSidebarTab === "settings"
                                    ? "border-b-2 border-blue-500 text-blue-500"
                                    : "text-gray-700"
                                    }`}
                                onClick={() => setActiveSidebarTab("settings")}>
                                Settings
                            </button>
                            <button
                                className={`py-3 px-4 flex-1 ${activeSidebarTab === "components"
                                    ? "border-b-2 border-blue-500 text-blue-500"
                                    : "text-gray-700"
                                    }`}
                                onClick={() =>
                                    setActiveSidebarTab("components")
                                }>
                                Components
                            </button>
                            <button
                                className={`py-3 px-4 flex-1 ${activeSidebarTab === "styles"
                                    ? "border-b-2 border-blue-500 text-blue-500"
                                    : "text-gray-700"
                                    }`}
                                onClick={() => setActiveSidebarTab("styles")}>
                                Styles
                            </button>
                        </div>

                        <button
                            className="absolute right-0 top-0 p-1 rounded-sm hover:bg-gray-100"
                            onClick={() => setSidebarOpen(false)}>
                            ❌
                        </button>
                    </div>

                    <div className="h-[calc(100%-48px)] overflow-auto">
                        {children}
                    </div>
                </>
            ) : (
                <button
                    className="p-2 hover:bg-gray-100"
                    onClick={() => setSidebarOpen(true)}>
                    ⚙️
                </button>
            )}
        </div>
    );
};

export default Sidebar;
